import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MetaPreviewData } from '../../../../../../../models/meta-template/preview-interfaces/meta-preview-data.interface';
import { MetaCreativeComponent } from '../../../preview-common/meta-creative/meta-creative.component';
import { MetaPreviewCopy } from '../../../preview-common/meta-preview-copy';

/**
 * Audience Network native: a card laid out by the publisher's app, with the
 * creative shown whole in a fixed-height slot, then the headline, two lines
 * of copy and an outlined button.
 */
@Component({
  selector: 'app-meta-audience-network-native',
  imports: [CommonModule, MetaCreativeComponent],
  templateUrl: './audience-network-native.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [
    '../../../preview-common/audience-network/audience-network-styles.scss',
    './audience-network-native.component.scss',
  ]
})
export class MetaAudienceNetworkNativePreviewComponent {
  @Input() data!: MetaPreviewData;

  readonly pageName = MetaPreviewCopy.FACEBOOK_PAGE_NAME;
  readonly avatar = MetaPreviewCopy.AVATAR;

  /** Both paragraphs on one run; CSS clamps it to two lines. */
  get primaryText(): string {
    return MetaPreviewCopy.flat(MetaPreviewCopy.primaryText(this.data));
  }

  get headline(): string {
    return MetaPreviewCopy.headline(this.data);
  }

  get cta(): string {
    return MetaPreviewCopy.cta(this.data);
  }
}
